// ============================================================
// HABIT OS — Bibliothek: Gut Health
// Probiotika · Präbiotika · Darm-Reparatur · Fermentierte Foods
// ============================================================

export const LIBRARY_GUT_HEALTH = {
  id: "gut_health",
  label: "Gut Health",
  icon: "🦠",
  subcategories: [

    // ── PROBIOTIKA ───────────────────────────
    {
      id: "gut_probiotics",
      label: "Probiotika",
      icon: "🧫",
      habits: [
        {
          id: "hab_probiotic_supplement",
          label: "Probiotikum (Multi-Strain)",
          time: "morning",
          icon: "💊",
          why: "Die Darmflora ist ein aktives Forschungsfeld. Ob ein Bakterienkultur-Präparat individuell sinnvoll ist, ist nicht pauschal belegt.",
          source: "Sonnenburg & Bäckhed, Nature, 2016 · Hill et al., Nature Reviews Gastroenterology, 2014",
          dose: "Laut Herstellerangabe. Bei Immunschwäche oder schweren Erkrankungen vorher ärztlich abklären.",
        },
        {
          id: "hab_bifidobacterium",
          label: "Bifidobacterium longum",
          time: "night",
          icon: "🌙",
          why: "Bifidobakterien sind ein natürlicher Teil der Darmflora. Ihr Nutzen als Präparat wird noch erforscht.",
          source: "Messaoudi et al., British Journal of Nutrition, 2011 · Pärtty et al., Pediatrics, 2015",
          dose: "Laut Herstellerangabe, abends",
        },
      ],
    },

    // ── PRÄBIOTIKA ───────────────────────────
    {
      id: "gut_prebiotics",
      label: "Präbiotika",
      icon: "🌾",
      habits: [
        {
          id: "hab_inulin",
          label: "Inulin / FOS",
          time: "morning",
          icon: "🧅",
          why: "Inulin ist ein Ballaststoff, z. B. aus Chicorée, Zwiebeln und Topinambur.",
          source: "Roberfroid et al., Journal of Nutrition, 2010 · Delannoy-Bruno et al., Nature, 2021",
          dose: "Laut Herstellerangabe, am besten morgens in den Shake oder Joghurt einrühren — langsam steigern",
        },
        {
          id: "hab_psyllium",
          label: "Flohsamenschalen (Psyllium)",
          time: "morning",
          icon: "🌿",
          why: "Flohsamenschalen sind ein quellfähiger Ballaststoff und unterstützen eine regelmäßige Verdauung.",
          source: "Anderson et al., American Journal of Clinical Nutrition, 2000 · Bijkerk et al., BMJ, 2009",
          dose: "Laut Herstellerangabe mit mindestens 300 ml Wasser. Mindestens 2 Std. Abstand zu Medikamenten.",
        },
        {
          id: "hab_resistant_starch",
          label: "Resistente Stärke",
          time: "flexible",
          icon: "🍌",
          why: "Resistente Stärke entsteht z. B. in abgekühlten Kartoffeln oder Reis und wirkt im Darm ähnlich wie ein Ballaststoff.",
          source: "Birt et al., Advances in Nutrition, 2013 · Robertson et al., Diabetologia, 2003",
          dose: "Regelmäßig einbauen: grüne Banane, abgekühlte Kartoffeln oder Reis, oder 1 EL rohes Kartoffelstärkepulver",
        },
      ],
    },

    // ── DARM-REPARATUR ───────────────────────
    {
      id: "gut_repair",
      label: "Ergänzungen",
      icon: "🔧",
      habits: [
        {
          id: "hab_colostrum",
          label: "Kolostrum",
          time: "morning",
          icon: "🥛",
          why: "Kolostrum ist die Erstmilch von Kühen und enthält u. a. Immunglobuline. Gesicherte Wirkungen beim Menschen sind begrenzt.",
          source: "Playford et al., American Journal of Clinical Nutrition, 2001 · Rathe et al., Nutrition Reviews, 2014",
          dose: "Laut Herstellerangabe. Bei Milcheiweißallergie nicht geeignet.",
        },
      ],
    },

    // ── FERMENTIERTE FOODS ───────────────────
    {
      id: "gut_fermented",
      label: "Fermentierte Foods",
      icon: "🫙",
      habits: [
        {
          id: "hab_kefir",
          label: "Kefir täglich",
          time: "morning",
          icon: "🥛",
          why: "Kefir ist ein fermentiertes Milchgetränk mit vielen verschiedenen Mikroorganismen-Stämmen. In einer Stanford-Studie (Cell, 2021) erhöhte eine Ernährung mit fermentierten Lebensmitteln die Vielfalt der Darmflora.",
          source: "Wastyk et al., Cell, 2021 · Bourrie et al., Frontiers in Microbiology, 2016",
          dose: "150–200 ml täglich, morgens — Vollfett bevorzugen für bessere Bioverfügbarkeit",
        },
        {
          id: "hab_kimchi",
          label: "Kimchi & Sauerkraut",
          time: "flexible",
          icon: "🥬",
          why: "Fermentiertes Gemüse wie Kimchi und Sauerkraut enthält Milchsäurebakterien und Ballaststoffe.",
          source: "Park et al., Journal of Medicinal Food, 2014 · Wastyk et al., Cell, 2021",
          dose: "50–100 g täglich, zu einer Mahlzeit — selbst fermentiert hat mehr lebende Kulturen als Supermarkt",
        },
        {
          id: "hab_kombucha",
          label: "Kombucha",
          time: "flexible",
          icon: "🫗",
          why: "Kombucha ist ein fermentiertes Teegetränk. Es kann Restalkohol enthalten, daher nicht in der Schwangerschaft.",
          source: "Jayabalan et al., Comprehensive Reviews in Food Science, 2014",
          dose: "120–240 ml täglich, ungepasteurisiert — auf Zuckergehalt achten (<5 g pro 100 ml)",
        },
        {
          id: "hab_miso",
          label: "Miso-Suppe",
          time: "morning",
          icon: "🍜",
          why: "Miso ist eine fermentierte Sojapaste. Sie ist salzreich, bei Bluthochdruck daher sparsam verwenden.",
          source: "Ito et al., Journal of Epidemiology, 2020 · Watanabe et al., Circulation Journal, 2022",
          dose: "1 Tasse Miso-Suppe täglich, morgens oder zum Mittagessen — immer nach dem Kochen auflösen, nie kochen",
        },
      ],
    },
  ],
};